var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"hl-legal-frame",attrs:{"frameborder":"0","src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }